import { AuthService } from '@/lib/auth';
import { handleRequestError } from '@/lib/utils/error';
import { clearAuthMeCache } from '@/features/user/api/user.cache';
import {
  login,
  loginByFacebook,
  loginByGoogle,
  register,
} from '@/features/auth/api/auth.api';
import { IRegisterForm } from '@/types/auth';
import { IRegister, ISignIn, ISignInFB, ISignInGoogle } from '@/shared';

function authenticateSession(token: string) {
  AuthService.authenticate(token);
}

function getAuthToken(response: {
  data?: { token?: string } | null;
  token?: string;
}): string | undefined {
  return response.data?.token ?? response.token;
}

function toRegisterPayload(payload: IRegisterForm): IRegister {
  const {
    policy: _policy,
    confirm_password: _confirmPassword,
    ...registerData
  } = payload;
  return registerData;
}

export async function loginWithCredentials(payload: ISignIn): Promise<string> {
  const { data } = await login(payload);
  const token = getAuthToken(data);
  if (!token) {
    throw new Error('Token not found');
  }
  authenticateSession(token);
  return token;
}

export async function registerWithCredentials(
  payload: IRegisterForm
): Promise<string> {
  try {
    const registerPayload = toRegisterPayload(payload);
    await register(registerPayload);

    const username =
      registerPayload.phone?.trim() || registerPayload.email?.trim();
    if (!username) {
      throw new Error('Phone or email is required after signup');
    }

    return loginWithCredentials({
      username,
      password: registerPayload.password,
      type: 'user',
    });
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
}

export async function loginWithFacebook(payload: ISignInFB): Promise<string> {
  try {
    const { data } = await loginByFacebook(payload);
    const token = getAuthToken(data);
    if (!token) {
      throw new Error('Token not found');
    }
    authenticateSession(token);
    return token;
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
}

export async function loginWithGoogle(
  payload: ISignInGoogle
): Promise<string> {
  try {
    const { data } = await loginByGoogle(payload);
    const token = getAuthToken(data);
    if (!token) {
      throw new Error('Token not found');
    }
    authenticateSession(token);
    return token;
  } catch (error) {
    handleRequestError(error);
    throw error;
  }
}

export function logoutSession() {
  AuthService.logout();
  localStorage.clear();
  clearAuthMeCache();
}
